import React, { useEffect, useState } from 'react';

import PageTitle from '../components/pagetitle/PageTitle';
import Footer from '../components/footer';

import icon1 from '../assets/images/svg/loaction.png'
import icon2 from '../assets/images/svg/email.png'
import icon3 from '../assets/images/svg/phone.svg'
import { useTranslation } from 'react-i18next';
import Loader from '../components/loader/loader';

function Contact(props) {
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        const handleLoad = () => {
            setIsLoading(false);
        };

        if (document.readyState === "complete") {
            setIsLoading(false);
        } else {
            window.addEventListener("load", handleLoad);    
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []);

    return (
        <>  {isLoading ? (
            <div style={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              height: "80vh",
              
            }}>
              <Loader />
            </div>
          ) : (
        <div>

            <PageTitle title={t('Contact')} />

            <section className="tf-contact ">
                <div className="tf-container">
                    <div className="row"> 
                        <div className="col-md-12">
                            <div className="tf-infor-wrap">
                                <div className="tf-infor">
                                    <div className="icon">
                                        <img height={40} width={40} src={icon1} alt="Binabox" />
                                    </div>
                                    <h3 className="title">{t('Location')}</h3>
                                    <p className="sub-title">1-75 Shelton Street Covent Garden London WC2H 9JQ UNITED KINGDOM</p>
                                </div>
                                <div className="tf-infor">
                                    <div className="icon">
                                        <img height={40} width={40} src={icon2} alt="Binabox" />
                                    </div>
                                    <h3 className="title">{t('Email')}</h3>
                                    <p className="sub-title">support@masterfut.com</p>
                                </div>
                                {/* <div className="tf-infor">
                                    <div className="icon">
                                        <img src={icon3} alt="Binabox" />
                                    </div>
                                    <h3 className="title">{t('Phone')}</h3>
                                    <p className="sub-title">+1 666 8888</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                  
                </div>
            </section>

            <Footer />
            
        </div>
        )}
        </>
    );
}

export default Contact;